import React from "react";
import { Activity, Clock, Layers } from "lucide-react";
import { QuickStatsCard } from "@features/cx/shared/components/QuickStatsCard";
import { useGetMeterScheduleSummary } from "@features/mx/readCycleManagement/hooks";

export const ScheduleDashboard: React.FC = () => {
  const { data: meterScheduleSummary } = useGetMeterScheduleSummary();
  console.log(meterScheduleSummary);
  const kpiCards = [
    {
      title: "Total Schedules",
      count: meterScheduleSummary?.statusSummary?.Total || 0,
      trendSummary: "All cycles with defined schedules",
      tooltip: "Count of all read cycles with defined schedules.",
      icon: <Layers className="h-8 w-8 text-blue-600" />,
    },
    {
      title: "Scheduled Count",
      count: meterScheduleSummary?.statusSummary?.Scheduled || 0,
      trendSummary: "Upcoming scheduled runs",
      tooltip: "Number of read cycles scheduled for future runs.",
      icon: <Clock className="h-8 w-8 text-purple-600" />,
    },
    {
      title: "Active Count",
      count: meterScheduleSummary?.statusSummary?.Active || 0,
      trendSummary: "Currently active operations",
      tooltip:
        "Number of read cycles currently active (not completed, not overdue).",
      icon: <Activity className="h-8 w-8 text-emerald-600" />,
    },
    {
      title: "Overdue Count",
      count: meterScheduleSummary?.statusSummary?.Overdue || 0,
      trendSummary: "Overdue operations",
      tooltip: " Number of read cycles that have passed their due date. ",
      icon: <Clock className="h-8 w-8 text-green-600" />,
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
      {kpiCards.map((card, index) => (
        <QuickStatsCard
          key={index}
          title={card.title}
          count={card.count}
          trendSummary={card.trendSummary}
          tooltip={card.tooltip}
          icon={card.icon}
          trendDirection={"up"}
        />
      ))}
    </div>
  );
};
